import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import i18n from '../../../../services/i18n';
import { createPayment } from '../../../../redux/reducers/common/thunks/paymentThunks';

const FLITT_CHECKOUT_URL = 'https://pay.flitt.com/api/checkout/redirect/';

export const useSubmitPayment = () => {
    const dispatch = useDispatch();

    return useCallback(
        async (payload) => {
            try {
                const params = await dispatch(
                    createPayment({ lang: i18n.language, ...payload }),
                ).unwrap();
                if (!params || typeof params !== 'object') {
                    throw new Error('Payment params not received');
                }
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = FLITT_CHECKOUT_URL;
                Object.entries(params).forEach(([key, value]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
            } catch (_) {
                toast.error(i18n.t('paymentError'));
            }
        },
        [dispatch],
    );
};
